// Add-agent navigation helpers — no React, no feature-module imports.
// AWS deployments always use quick mode. Azure and GCP stay on the full add-agent wizard.

export const AGENTS_MGMT_PATH = "/agents-mgmt";
export const ADD_AGENT_PATH = "/agents-mgmt/add-agent";
export const QUICK_ADD_AGENT_PATH = "/agents-mgmt/quick-add-agent";
export const HOME_PATH = "/home";
export const WORKING_ENVIRONMENTS_PATH = "/working-environments";

export const getAddAgentExitPath = (provider, marketplaceRow) => {
    const normalizedProvider = provider?.toLowerCase();
    const marketplaceProvider = marketplaceRow?.cloudProvider?.toLowerCase();
    return marketplaceProvider && normalizedProvider === marketplaceProvider ? HOME_PATH : AGENTS_MGMT_PATH;
};

export const buildQuickAddAgentLocation = (cloudProvider, state) => ({
    pathname: `${QUICK_ADD_AGENT_PATH}/${cloudProvider?.toLowerCase()}`,
    ...(state ? { state } : {}),
});

/**
 * Canonical cloud-agent deployment location.
 *
 * AWS is always deployed through quick mode. Azure and GCP continue to use the full add-agent wizard
 * until their quick-mode implementations are available.
 */
export const buildAddAgentLocation = (cloudProvider, state = {}) => {
    const provider = cloudProvider?.toLowerCase();
    const navigationState = state || {};

    if (provider === "aws") {
        return buildQuickAddAgentLocation(
            provider,
            Object.keys(navigationState).length ? navigationState : undefined
        );
    }

    return {
        pathname: ADD_AGENT_PATH,
        state: {
            ...navigationState,
            selectedProvider: provider,
        },
    };
};

export const buildResumeAddAgentLocation = (cloudProvider) =>
    buildAddAgentLocation(cloudProvider, {
        navigatingFrom: {
            pageName: "licenses_marketplace_aws",
            routePath: WORKING_ENVIRONMENTS_PATH,
        },
    });

// Post-association redirect for the AWS cvo-product marketplace flow: agent deployment is done in
// quick mode here, not in the full add-agent wizard.
export const buildMarketplaceAssociateAddAgentLocation = () =>
    buildQuickAddAgentLocation("aws");
